// Shared adminPermission-domain i18n keys for the UserPermissionGroup widget
// (mounted by UserAdd and RoleAddModal). Keys live under `adminPermission.*`
// because the widget is reused across multiple admin sub-domains.

export const adminPermissionDict: Record<string, [en: string, th: string]> = {
  "adminPermission.selectAll": ["Select All Permissions", "เลือกสิทธิ์ทั้งหมด"],
  "adminPermission.selectedCount": ["{selected} of {total} selected", "เลือกแล้ว {selected} จาก {total}"],
};
